import { useMemo } from "react";
import { titleCase } from "title-case";

/** Either shape the card policy arrives in: the form's, or the server's. */
interface MerchantSource {
  allowedMerchants?: { id?: string; name?: string | null }[] | null;
  merchants?: { id?: string; name?: string | null }[] | null;
}

/**
 * The merchant names on a card policy, title cased.
 *
 * Returns names rather than markup: it used to build its own List, truncate
 * past three and hide the rest behind a hover, which meant a card with four
 * restrictions showed none of them to anyone who could not point at it. The
 * caller decides how to draw them.
 */
const useListMerchant = (
  cardPolicy?: MerchantSource | null,
  /** Kept for the call sites; the hook renders no strings of its own. */
  _t?: unknown,
): string[] =>
  useMemo(() => {
    const merchants = cardPolicy?.allowedMerchants ?? cardPolicy?.merchants;
    if (!merchants) return [];
    return merchants
      .map((item) => item?.name)
      .filter((name): name is string => Boolean(name))
      .map((name) => titleCase(name.toLowerCase()));
  }, [cardPolicy?.allowedMerchants, cardPolicy?.merchants]);

export default useListMerchant;
